import axios from "axios";

const ROUTE = '/rest/v4/firebase/devices';
const PUSH_ROUTE = '/rest/v4/firebase/message';

export default {

    getAll() {
        return axios.get(ROUTE);
    },

    get(id) {
        return axios.get(`${ROUTE}/${id}`);
    },

    post(data) {
        return axios.post(ROUTE, data);
    },

    put(id, data) {
        return axios.post(`${ROUTE}/${id}`, data);
    },

    delete(id) {
        return axios.delete(`${ROUTE}/${id}`);
    },

    pushMessage(title, message) {
        return axios.post(PUSH_ROUTE, { title, message });
    }
}
